@if (paginator.state$ | async; as paginatorState) {
	<div
		name="table-container"
		class="bg-base-100 card border-base-200 w-full overflow-x-auto border shadow-sm"
	>
		<table
			name="table-body"
			class="table w-full"
		>
			<thead class="bg-base-200/50 text-base-content/60 text-xs font-bold tracking-wider uppercase">
				<tr>
					<!-- selection header -->
					<th class="selection-column w-12 text-center">
						<div class="flex justify-center">
							{{ itemsSelector.numSelected ? itemsSelector.numSelected : '' }}
						</div>
					</th>
					<!-- invoice name header -->
					<th class="py-4">
						<div class="flex items-center gap-2">
							<span class="text-nowrap" [translate]>number</span>
							<div class="join">
								<button class="btn btn-ghost btn-xs join-item" (click)="paginator.setOrderingBy('number')" title="Sort">↑↓</button>
								<button
									class="btn btn-ghost btn-xs join-item"
									[class.btn-active]="displaySearchByFields$_['number']"
									(click)="toggleSearchByField('number')"
									title="Search"
								>🔎</button>
							</div>
						</div>
						@if (displaySearchByFields$_['number']) {
							<div class="mt-2">
								<input class="input input-bordered input-xs w-full max-w-xs" type="text" placeholder="Search..." [(ngModel)]="filterByFields$_['number']" />
							</div>
						}
					</th>
					<th class="py-4">
						<div class="flex items-center gap-2">
							<span class="text-nowrap" [translate]>issued</span>
							<button class="btn btn-ghost btn-xs" (click)="paginator.setOrderingBy('issue_date')">↑↓</button>
						</div>
					</th>
					<th class="py-4 text-right"><span [translate]>total</span></th>
					<th class="py-4"><span [translate]>status</span></th>
					<th class="w-20 py-4 text-center"><span [translate]>download</span></th>
					<!-- actions header -->
					<th class="w-20 py-4 text-center">
						<span [translate]>actions</span>
					</th>
				</tr>
			</thead>
			<tbody>
				@for (invoice of paginatorState.itemsOnCurrentPage; track invoice?.id) {
					<!--  -->

					@if (invoice) {
						<tr
							[tabIndex]="0"
							(click)="processClick(invoice)"
							(keyup.enter)="processClick(invoice)"
							class="hover:bg-base-200/50 cursor-pointer transition-colors duration-150"
							[class.bg-primary/10]="itemsSelector.isSelected(invoice)"
						>
							<!-- selection -->
							<td class="text-center">
								<div
									class="flex justify-center"
									(click)="$event.stopImmediatePropagation(); itemsSelector.toggle(invoice)"
									(keydown)="(undefined)"
									tabindex="0"
								>
									<input
										class="checkbox checkbox-primary checkbox-sm"
										[name]="'selectedItems' + invoice.id"
										type="checkbox"
										[checked]="itemsSelector.isSelected(invoice)"
										tabindex="0"
									/>
								</div>
							</td>
							<!-- number -->
							<td>
								<div class="text-base-content font-mono font-medium">{{ invoice.number }}</div>
							</td>
							<!-- issued -->
							<td>
								<div class="text-base-content/60 text-xs">{{ invoice.config.issueDate | date: 'dd MMM yyyy' }}</div>
							</td>
							<!-- total -->
							<td class="text-right whitespace-nowrap">
								{{ invoice.config.totals.totalTtc | currency: invoice.config.currency }}
							</td>
							<!-- status -->
							<td>
								<span class="badge badge-sm" [class.badge-warning]="invoice.status === 'draft'" [class.badge-success]="invoice.status === 'issued'">
									{{ invoice.status }}
								</span>
							</td>
							<!-- download: only an issued document has a rendered file behind it -->
							<td class="text-center">
								@if (invoice.config.pdfFileId; as pdfFileId) {
									<lib-download-button
										(click)="$event.stopImmediatePropagation()"
										[entityFileId]="pdfFileId"
										[downloadName]="invoice.number + '.pdf'"
									></lib-download-button>
								} @else {
									<span class="text-base-content/30 text-xs" [translate]>not issued</span>
								}
							</td>
							<!-- actions -->
							<td class="text-center">
								@if (!readonly()) {
								<button
									(click)="$event.stopImmediatePropagation()"
									[cdkMenuTriggerFor]="menu"
									class="btn btn-ghost btn-sm btn-square"
									[attr.aria-label]="'menu' | translate | async"
								>
									<!-- svg three dots more -->
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										class="h-5 w-5 stroke-current"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
										/>
									</svg>
								</button>

								<ng-template #menu>
									<ul
										class="menu bg-base-100 rounded-box border-base-200 w-56 border p-2 shadow-xl"
										cdkMenu
									>
										<li cdkMenuItem>
										</li>
										<li cdkMenuItem>
											<button
												(click)="deleteInvoice(invoice)"
												class="text-error flex items-center gap-2"
											>
												<span [translate]>Delete</span>
											</button>
										</li>
										<li cdkMenuItem>
											<button
												(click)="openSharingDetails(invoice)"
												class="flex items-center gap-2"
											>
												<span [translate]>Manage Access</span>
											</button>
										</li>
										<li cdkMenuItem>
											<button
												(click)="shareWithTeam(invoice)"
												class="flex items-center gap-2"
											>
												<span [translate]>Share with a team</span>
											</button>
										</li>
										<div class="divider my-1"></div>
										<li class="menu-title px-4 py-2 text-[10px] uppercase opacity-40">Item id: {{ invoice.id.substring(0, 8) }}</li>
									</ul>
								</ng-template>
								}
							
							</td>
						</tr>

						@if (openedItems.isSelected(invoice)) {
							<tr
								class="bg-base-200/20"
								fullSpanRow
							>
								<td class="relative p-8">
									<button
										class="btn btn-ghost btn-xs absolute top-2 right-2"
										(click)="openedItems.unselect(invoice)"
									>
										<span
											class="text-xs italic"
											[translate]
											>close display</span
										>
									</button>
									@if (expandedRow(); as panel) {
										<ng-container [ngTemplateOutlet]="panel" [ngTemplateOutletContext]="{ $implicit: invoice }"></ng-container>
									} @else {
										<span class="text-base-content/50 italic">nothing here</span>
									}
								</td>
							</tr>
						}
					} @else {
						<tr>
							<td
								colspan="7"
								class="text-center"
							>
								<span class="loading loading-spinner loading-md text-primary"></span>
							</td>
						</tr>
					}
				} @empty {
					<tr>
						<td
							colspan="7"
							class="text-base-content/50 py-12 text-center italic"
						>
							{{ 'Nothing here' | translate | async }}
						</td>
					</tr>
				}
			</tbody>
		</table>
		<lib-table-paginator [paginator]="paginator" />
	</div>
}
